import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetInstitutions = async (setLoading, userId) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/institutions`, {
      headers: apiConfig.headers,
      data: {
        userId,
      },
    });
    return result;
  } catch (error) {
    console.error("Error fetching institutions:", error);
    return error;
  }
};

export const APIUpdateInstitutionTimezone = async (
  institutionId,
  timezone,
  setLoading
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/institutions/timezone`,
      {
        institutionId,
        timezone,
      },
      {
        headers: apiConfig.headers,
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating institution timezone:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIUpdateInstitutionTripTypes = async (
  institutionId,
  tripTypes,
  setLoading
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/institutions/trip-types`,
      {
        institutionId,
        tripTypes,
      },
      {
        headers: apiConfig.headers,
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating institution trip types:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
